import { render } from "./UpdatePatient.vue?vue&type=template&id=c4a44494&ts=true"
import script from "./UpdatePatient.vue?vue&type=script&lang=ts"
export * from "./UpdatePatient.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__